import { render, staticRenderFns } from "./Transform.vue?vue&type=template&id=6eea225b&scoped=true&"
import script from "./Transform.vue?vue&type=script&lang=js&"
export * from "./Transform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eea225b",
  null
  
)

export default component.exports